import React, { useRef } from "react";
import styled from "styled-components";
import { FocalPoint } from "../../../schemas/Media";
import { useOptimizedSrc } from "../hooks";
import { useResizeDetector } from "react-resize-detector";
const StyleableImage = React.forwardRef(({ media, optimized, crop = false, fit, quality, pixelRatio, focalPoint, ...htmlProps }, ref) => {
    const { url, accessibilityText = "", dimensions } = media;
    const desiredFocalPoint = focalPoint || media.focalPoint || FocalPoint.CENTER;
    const targetRef = useRef(ref);
    const { width, height, ref: resizeRef } = useResizeDetector({ targetRef });
    const containerDimensions = { width: width || 0, height: height || 0 };
    const optimizedSrc = useOptimizedSrc({
        imageDimensions: dimensions,
        containerDimensions,
        quality: quality,
        focalPoint: desiredFocalPoint,
        crop,
        pixelRatio,
        fit,
        url,
    });
    const src = optimized ? optimizedSrc : url;
    return React.createElement("img", { ref: resizeRef, src: src, alt: accessibilityText, ...htmlProps });
});
StyleableImage.defaultProps = {
    "data-testid": "sanityImage",
};
StyleableImage.displayName = "SanityImg";
export const SanityImage = styled(StyleableImage) `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=SanityImage.js.map